// @ts-nocheck
import { h } from "preact";
import { Modal } from "antd";
import { useEffect, useState, useImperativeHandle } from "preact/hooks";
import { forwardRef } from "react";
import { useForm } from "react-hook-form";
import { Text } from "../../../../components/text";
import { useMessage } from "../../../../hooks/useMessage";
import { TablePreview } from "../table/preview";
import { COULMN_PREVIEW } from "../../constants/columns";
import { useFileExcell } from "../../hook/useFileExcel";

export const PreviewUpload = forwardRef<any, IPropsModal>((props, ref) => {
  const { data, isDisabled, onCallBackModalUpload } = props;
  const { onSaveUploadFileExcel } = useFileExcell();
  const { openMessage } = useMessage();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const { reset, handleSubmit } = useForm({});

  useEffect(() => {
    !visible && reset();
  }, [visible]);

  useImperativeHandle(ref, () => ({
    async openModal() {
      setVisible(true);
    },
  }));

  const onConfirm = async () => {
    setLoading(true);
    try {
      const res = await onSaveUploadFileExcel(data);
      if (!res) {
        return;
      }
      const resetFileUplaod = [];
      onCallBackModalUpload && onCallBackModalUpload(resetFileUplaod);
      setLoading(false);
      setVisible(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      openMessage("error", (error as Error).message);
    }
  };

  return (
    <Modal
      centered
      width={1200}
      title={(<Text size={"L"} text={`ตัวอย่าง`} bold />) as React.ReactNode}
      transitionName={""}
      visible={visible}
      okText={"บันทึก"}
      cancelText={"ยกเลิก"}
      confirmLoading={loading}
      onCancel={() => setVisible(false)}
      onOk={handleSubmit(onConfirm)}
      okButtonProps={{ disabled: isDisabled }}
    >
      <TablePreview data={data} columns={COULMN_PREVIEW()} />
    </Modal>
  );
});
